import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import _ from "@lodash";
import TextField from "@mui/material/TextField";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { Card, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useParams } from "react-router-dom";
import HostImportantDaysTable from "./components/hostImportantdaysTable";
import { AutoAwesome } from "@mui/icons-material";

const defaultValues = {
  registrationStartDate: "",
  registrationEndDate: "",
  deadlineToPostJobs: "",
  deadlineToHireCandidates: "",
  deadlineToDeleteJobs: "",
  deadlineToSubmitHostAgreement: "",
  description: "",
  date: "",
};

const schema = yup.object().shape({});

export default function HostImportantDays() {
  const [isAiLoading, setIsAiLoading] = useState(false);
  const routeParams = useParams();
  const { id } = routeParams;

  const { control, handleSubmit, watch, formState, setValue } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { isValid, dirtyFields, errors } = formState;
  const form = watch();

  const [formValues, setFormValue] = useState({
    employeeType: "",
  });

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormValue({
      ...formValues,
      [name]: value,
    });
  };

  const generateDates = async () => {
    setIsAiLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 3000));
    setValue("registrationStartDate", "2025-02-15");
    setValue("registrationEndDate", "2025-03-15");

    setValue("deadlineToPostJobs", "2025-03-31");
    setValue("deadlineToHireCandidates", "2025-04-30");
    setValue("deadlineToDeleteJobs", "2025-04-15");
    setValue("deadlineToSubmitHostAgreement", "2025-02-01");
    setIsAiLoading(false);
  };

  return (
    <>
      <Button
        className="mt-2 ml-24 bg-gradient-to-r from-green-400 to-blue-500"
        variant="contained"
        disabled={isAiLoading}
        startIcon={<AutoAwesome />}
        onClick={() => generateDates()}
      >
        {isAiLoading ? "Generating..." : "Generate with AI"}
      </Button>
      <Card variant="outlined" className="m-24 mb-0">
        <div className="m-24 mt-8">
          <div className="flex grid lg:grid-cols-2 md:grid-cols-3 sm:grid-cols-2 gap-16 content-start">
            <div className="flex">
              <Controller
                control={control}
                name="registrationStartDate"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Registration Start Date"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>
            <div className="flex">
              <Controller
                control={control}
                name="registrationEndDate"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Registration End Date"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>

            <div className="flex">
              <Controller
                control={control}
                name="deadlineToPostJobs"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Deadline to Post Jobs"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>
            <div className="flex">
              <Controller
                control={control}
                name="deadlineToHireCandidates"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Deadline to Hire Candidates"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>

            <div className="flex">
              <Controller
                control={control}
                name="deadlineToDeleteJobs"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Deadline to Delete Jobs"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>
            <div className="flex">
              <Controller
                control={control}
                name="deadlineToSubmitHostAgreement"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Deadline to Submit Host Agreement"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>

            <Controller
              control={control}
              name="description"
              render={({ field }) => (
                <TextField
                  {...field}
                  className="mt-16 w-full"
                  label="Description"
                  placeholder="Description"
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={!!errors.description}
                  helperText={errors?.description?.message}
                />
              )}
            />
            <Controller
              control={control}
              name="date"
              render={({ field }) => (
                <DatePicker
                  className="mt-16 w-full"
                  label="Date"
                  value={field.value ? new Date(field.value) : null}
                  onChange={(date) => field.onChange(date?.toISOString())}
                  slotProps={{ textField: { size: "small" } }}
                />
              )}
            />
          </div>
          <div className="flex mt-24">
            <Button
              className="mx-8"
              variant="contained"
              color="secondary"
              disabled={false}
            >
              Add
            </Button>
          </div>
          <HostImportantDaysTable />
          <div className="flex items-center justify-end mt-32">
            <Button
              className="mx-8"
              variant="contained"
              color="secondary"
              disabled={false}
            >
              Save
            </Button>
          </div>
        </div>
      </Card>
    </>
  );
}
